// soccer_admin/src/components/Layout.jsx
import React, { useState } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { 
  HomeIcon, UsersIcon, CreditCardIcon, TrophyIcon, CogIcon ,
  CalendarIcon, ChatBubbleLeftRightIcon, ArrowRightOnRectangleIcon,
  Bars3Icon, XMarkIcon, BellIcon , EnvelopeIcon, StarIcon , BugAntIcon 
} from '@heroicons/react/24/outline';
import { adminLogout } from '../services/api';

const navigation = [
  { name: 'Dashboard', href: '/', icon: HomeIcon },
  { name: 'Users', href: '/users', icon: UsersIcon },
  { name: 'Cards', href: '/cards', icon: CreditCardIcon },
  { name: 'Leagues', href: '/leagues', icon: TrophyIcon },
  { name: 'Matches', href: '/matches', icon: CalendarIcon },
  { name: 'Support', href: '/support', icon: ChatBubbleLeftRightIcon },
  { name: 'Send Notification', href: '/notifications', icon: BellIcon },
  { name: 'Error Logs', href: '/errors', icon: BugAntIcon },
  { name: 'Seasons', href: '/seasons', icon: CalendarIcon },
  { name: 'Maintenance', href: '/maintenance', icon: CogIcon },
  { name: 'Sponsorship', href: '/sponsorship', icon: EnvelopeIcon },
  { name: 'Premium Names', href: '/premium-names', icon: StarIcon }
];

const Layout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await adminLogout();
    navigate('/login');
    window.location.reload();
  };

  return (
    <div className="flex h-screen bg-gray-900">
      {/* Desktop Sidebar (fixed) */}
      <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 bg-gray-800 text-white">
        <div className="p-4 text-2xl font-bold border-b border-gray-700">Soccer Admin</div>
        <nav className="flex-1 mt-6">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className="flex items-center px-4 py-2 text-gray-300 hover:bg-gray-700 hover:text-white"
            >
              <item.icon className="h-5 w-5 mr-3" />
              {item.name}
            </Link>
          ))}
        </nav>
        <div className="p-4 border-t border-gray-700">
          <button
            onClick={handleLogout}
            className="flex items-center w-full px-4 py-2 text-gray-300 hover:bg-gray-700 hover:text-white"
          >
            <ArrowRightOnRectangleIcon className="h-5 w-5 mr-3" />
            Logout
          </button>
        </div>
      </div>

      {/* Mobile header with hamburger */}
      <div className="md:hidden fixed top-0 left-0 right-0 z-20 bg-gray-800 border-b border-gray-700 px-4 py-3 flex justify-between items-center">
        <div className="text-xl font-bold text-white">Soccer Admin</div>
        <button onClick={() => setMobileMenuOpen(true)} className="text-white">
          <Bars3Icon className="h-6 w-6" />
        </button>
      </div>

      {/* Mobile drawer sidebar */}
      <div
        className={`fixed inset-0 z-30 transition-transform duration-300 transform ${
          mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
        } md:hidden`}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0 bg-black/70"
          onClick={() => setMobileMenuOpen(false)}
        />
        {/* Sidebar panel */}
        <div className="relative w-64 bg-gray-800 h-full shadow-xl flex flex-col">
          <div className="flex justify-between items-center p-4 border-b border-gray-700">
            <span className="text-xl font-bold text-white">Soccer Admin</span>
            <button onClick={() => setMobileMenuOpen(false)} className="text-white">
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>
          <nav className="flex-1 mt-4">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center px-4 py-3 text-gray-300 hover:bg-gray-700 hover:text-white"
              >
                <item.icon className="h-5 w-5 mr-3" />
                {item.name}
              </Link>
            ))}
          </nav>
          <div className="p-4 border-t border-gray-700">
            <button
              onClick={() => {
                handleLogout();
                setMobileMenuOpen(false);
              }}
              className="flex items-center w-full px-4 py-2 text-gray-300 hover:bg-gray-700 hover:text-white"
            >
              <ArrowRightOnRectangleIcon className="h-5 w-5 mr-3" />
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Main content area */}
      <div className="flex-1 md:ml-64 overflow-auto pt-16 md:pt-0">
        <div className="p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;